import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/Layout.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/home',
                    component: () => import(/* webpackChunkName: "dashboard" */ './../page/Home.vue'),
                    meta: { title: '客户管理' }
                },
                 {
                    path: '/department',
                    component: () => import(/* webpackChunkName: "dashboard" */ './../page/department.vue'),
                    meta: { title: '门店管理' }
                }
            ]
        }
        // {
        //     path: '/login',
        //     component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
        //     meta: { title: '登录' }
        // }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js